let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("d1Sbh")).then(() => parcelRequire('4Miat'));